import { render, staticRenderFns } from "./PlanejamentoFluxoModalPendencias.vue?vue&type=template&id=60c31192&lang=html"
import script from "./PlanejamentoFluxoModalPendencias.vue?vue&type=script&lang=js"
export * from "./PlanejamentoFluxoModalPendencias.vue?vue&type=script&lang=js"
import style0 from "./PlanejamentoFluxoModalPendencias.vue?vue&type=style&index=0&id=60c31192&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports